import { useEffect } from "react";
import { Outlet, useLocation } from 'react-router-dom';
import { observer } from "mobx-react-lite";
import { useStore } from "../stores/store";
import { ToastContainer } from "react-toastify";
import SkeltonAnimation from "./SkeltonAnimation";
import ModalContainer from "../common/Modals/ModalContainer";
import { Box } from "@mui/material";
import AppFooterCopyRight from "../../features/footer/AppFooterCopyRight";
import HomePage from "../../features/home/HomePage";
import useQuery from "../common/util/hooks";
import { router } from "../router/Routes";

function App() {
  const location = useLocation();
  const { commonStore, userStore } = useStore();

  const email = useQuery().get('email') as string;
  const token = useQuery().get('token') as string;
  const redirectUrl = useQuery().get('redirectUrl') as string;

  useEffect(() => {
    if (email && token && redirectUrl) {
      commonStore.resetAppData();
      router.navigate(`/account/${redirectUrl}?token=${token}&email=${email}`);
    } else {
      if (commonStore.token) {
        userStore.getUser().finally(() => commonStore.setAppLoaded());
      } else {
        commonStore.setAppLoaded();
      }
    }

  }, [commonStore, email, redirectUrl, token, userStore])

  if (!commonStore.appLoaded) return <SkeltonAnimation iteration={15} />
  return (
    <>
      <ToastContainer position='bottom-right' hideProgressBar />
      <ModalContainer />
      <Box sx={{ mt: 12}}>
        {location.pathname === '/' ? <HomePage /> : (
          <Box component={'div'} sx={{ typography: 'body1', minHeight: '100vh' }}>
            <Outlet />
          </Box>
        )
        }
      </Box>
      <AppFooterCopyRight />
    </>
  );
}
export default observer(App);
